"use strict";
/**
 * Share-related type definitions
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=share.js.map